import { render, staticRenderFns } from "./SubjectContent.vue?vue&type=template&id=9d8a05c8&"
import script from "./SubjectContent.vue?vue&type=script&lang=js&"
export * from "./SubjectContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports